import React from "react";
import shishir from "./Shishir.jpeg";
import "./blogs.css";

const Shishir = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src={shishir}
            style={{ height: "345px", width: "83%" }}
            alt="Shishir"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Shishir</h2>
            <small>Software Engineer at American Express</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col--md-12">
            <h3>Introduction </h3>
            <p>
              Hey everyone, I’m Shishir, a Y21 B.Tech student from the Civil Engineering department. I’ve recently joined American Express, Bangalore, as a Software Engineer. My journey at IIT Kanpur has been a continuous upward curve of growth and learning—both personally and professionally. Let me take you through my college experience.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/shishir/1.png"
          alt="shishir"
        />
        

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Preparation for Job/Internship</h3>
            <p>
              I had been coding since school and had a good grasp of Java. However, my skills got rusty during JEE preparation. In my first year, I learned C, and thanks to ESC101, I managed to get a decent CPI of 7.5. Since the semesters were online, I thought I was doing well—especially because a random senior once told me that 6.5 was considered good!
            </p>

            <p>
              When I finally came to campus, I wanted to explore everything—MClub, cricket, badminton, PClub. I really admired Shivam Mishra, a senior from Civil who was the PClub coordinator and incredibly talented. Later, I learned that as a Civil Engineering student, I’d need a CPI above 8 to qualify for most top company shortlists.
            </p>
            
            <p>
              Thanks to seniors like Subodh Kasaudhan, Harsh Chaudhary, Prem Millind Gujarati, and others who guided me, I decided to put exploration on hold and focus entirely on academics. By the end of the second semester, I had a CPI of 7.2—still below my goal. I used to feel frustrated back then.
            </p>

            <p>
                The third semester became the turning point of my life. I spent my days entirely in the library—from 8 AM to midnight—and at NCL from midnight to 2 AM. My daily routine was simple: attend classes, eat lunch and dinner, and study. I aimed for a perfect 10 but ended up securing a 9.5 CPI.


            </p>
            <p>
                That semester, I also found my core group—Ayush Yadav, Aryan Kumar, Sushmit Dagar, Harshit Patel, and Gaurav Sharma—all wingmates from Civil. I’m proud to be their friend. Before exams, I’d study first and then teach them (though I never liked the nickname they gave me—“Shishir God”).
            </p>
            <p>
                In the next semester, I formed another close-knit group—Sandipan Dutta, Shambhavi Agarwal, Shrey Patel, Vedant Adlak, and Shruti Goyal. We often had group study sessions, last-minute assignment rushes, and project marathons together. I scored another 9-pointer that semester, finally joining the 8-pointer club, which meant I could now compete for placements at top companies.
            </p>
            <p>
                However, I still needed stronger coding skills. That’s when Shwetank Anand, Saket Jain, Aditya Kumar, and Mihir Mittal introduced me to competitive programming. Shwetank, in particular, was a huge help—sharing resources and guiding me throughout. I practiced on Codeforces and CodeChef, later switching to LeetCode and InterviewBit. Striver’s A-to-Z DSA Sheet became my bible, and I still follow it today.

                I also did a summer project under Prof. Salil Goel on Automatic LiDAR Registration, where I learned the basics of machine learning and big data analytics. I worked on a few other projects under SnT and Stamatics, but honestly, I still didn’t feel ready for the internship season.

            </p>
            
            <p>
                When preparing my resume, I was convinced I wouldn’t get selected. I even considered opting out of Phase 1 and working on a startup idea instead. But after talking to Parul Singh (Y20), I decided to submit my resume anyway.

                The first week brought a series of rejections—until I finally got a shortlist: American Express. I knew this was my golden chance, maybe my only one, given the fierce competition

            </p>
            <img
          class="blog-image-right"
          src="/placement-postulates/blogs/shishir/4.png"
          alt="shishir"
        />
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/shishir/2.png"
          alt="shishir"
        />
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/shishir/5.png"
          alt="shishir"
        />
          </div>
        </div>
        <img
          class="blog-image-left"
          src="/placement-postulates/blogs/shishir/3.png"
          alt="shishir"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Interview Experience</h3>
            <p>
              I was sitting in class when a CoCo messaged me that I had an interview scheduled in two hours. I had no time to prepare, but I quickly began revising puzzles, tree traversals, and graph problems. I was panicking—badly.

              That’s when my roommate, Priyanshu Gangwar, stepped in. He’s one of those people who always believed in me and helped me calm down.

              I headed to the SPO office for my first interview—Round 1. It began with a brief introduction, followed by technical questions from my resume, projects, and listed programming languages. Then came two DSA problems. I cleared the round.
            </p>
            <p>
              Round 2 was a mix of technical and HR questions. My resume was discussed in detail, and I was evaluated on teamwork, eagerness to learn, and contribution potential.

              Finally, I was selected. The moment Adityaraj messaged me the confirmation—it’s still etched in my memory. All my hard work and sacrifices finally felt worth it.

              Later, I also received a PPO. My last semester was pure bliss—playing cricket, going on trips, exploring campus, and making memories for life. I’m grateful for every bond I formed—with seniors, juniors, and especially my batchmates. During the placement season, our wing truly became a family. We ran around for every wingie’s placement—sleep-deprived, hungry, and tired—but every success felt like our own. We celebrated each one with immense joy.

            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        
    
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Advice for Juniors</h3>
            <p>
              These four years are among the most crucial of your life. There will be times when you feel hopeless and directionless. Life might seem harsh. You’ll face academic, career, and peer pressure, family expectations, and self-doubt. But during those times, believe in yourself.

              Keep showing up every day for your goals. Winning or losing doesn’t matter—focus on the bigger picture. Believe that the best days are yet to come. Work hard genuinely and never give up.

            </p>
            <p>
              Build meaningful relationships with seniors. Have friends who will always have your back. Be a helpful batchmate. Guide your juniors and help them find purpose.

              Most importantly—learn patience. When things don’t go your way, stay calm and keep working hard. Focus on what you can control instead of worrying about outcomes. Don’t stress over shortlists; focus on learning instead of anxiety.

            </p>
        
          </div>
        </div>
    
      </div>
    </div>
  );
};

export default Shishir;
